import React from 'react';
import { useSelector } from 'react-redux';
import { MotionLink } from 'features/motion-router';

import styles from './LunchPageFilterBadge.module.scss';
import { getAllowedDiets } from 'store/foods/selectors';
import { useTranslation } from 'features/translator';
import { ReactComponent as DietIcon } from './assets/diet.svg';

const DietFilterBadge: React.FunctionComponent = () => {
  const allowedDiets = useSelector(getAllowedDiets);
  const translation = useTranslation();

  return (
    <MotionLink to="/asetukset/ruokavalio" className={styles.component}>
      <span className={styles.dietsButton}>
        <DietIcon className={styles.buttonIcon} />
        {translation.get('foodsPage', 'diets')}
        {allowedDiets.length > 0 && (
          <span className={styles.count}>{allowedDiets.length}</span>
        )}
      </span>
    </MotionLink>
  );
};

export default DietFilterBadge;
